
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/articles/[id]",
      function () {
        return require("private-next-pages/support/articles/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/articles/[id]"])
      });
    }
  